import { render, staticRenderFns } from "./app.vue?vue&type=template&id=09f70fde"
import script from "./app.ts?vue&type=script&lang=js&external"
export * from "./app.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f70fde')) {
      api.createRecord('09f70fde', component.options)
    } else {
      api.reload('09f70fde', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=09f70fde", function () {
      api.rerender('09f70fde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/app/app.vue"
export default component.exports